import type { ModuleId } from '../content/content'

/**
 * Lijniconen voor de zes hoofdtegels. Eén lijndikte, één hoekstijl, afgeronde
 * uiteinden — dezelfde taal als de rest van de kiosk. Ze staan absoluut in de
 * tegel en tellen dus niet mee in de tekstbaan (zie `meetAfkapping` in
 * `scripts/schermafdrukken.mjs`): de ruimte die ze vullen was leeg.
 */
const PADEN: Record<ModuleId, JSX.Element> = {
  // Autonome truck: body, mast, vork, en de golven van de scanner.
  automatisering: (
    <>
      <path d="M8 36V22h14l4 6v8" />
      <path d="M26 36h10M30 14v22M30 30h10" />
      <circle cx="13" cy="37" r="3" />
      <circle cx="23" cy="37" r="3" />
      <path d="M14 16a6 6 0 0 1 6 0M11.5 12.5a11 11 0 0 1 11 0" />
    </>
  ),
  // Schild met vinkje.
  veiligheid: (
    <>
      <path d="M24 6 38 11v11c0 9-6 16-14 20-8-4-14-11-14-20V11z" />
      <path d="m17 24 5 5 9-10" />
    </>
  ),
  // Batterij met bliksem.
  energie: (
    <>
      <rect x="8" y="14" width="28" height="20" rx="3" />
      <path d="M36 21h3v6h-3" />
      <path d="m23 17-5 8h7l-4 7" />
    </>
  ),
  // Drie verbonden knooppunten.
  connectiviteit: (
    <>
      <circle cx="12" cy="30" r="4" />
      <circle cx="36" cy="30" r="4" />
      <circle cx="24" cy="12" r="4" />
      <path d="M15 27 21.5 15.5M26.5 15.5 33 27M16 30h16" />
    </>
  ),
  // Stelling: twee staanders, twee liggers, op elk niveau een doos.
  stellingen: (
    <>
      <path d="M10 6v36M38 6v36M10 18h28M10 32h28" />
      <rect x="15" y="22" width="10" height="10" rx="1" />
      <rect x="24" y="9" width="9" height="9" rx="1" />
    </>
  ),
  // Opzit-schrobmachine: kap met stoel en stuur, wielen, borstel eronder, en
  // een druppel.
  tennant: (
    <>
      <path d="M8 35V26a3 3 0 0 1 3-3h12l5 5h7a2 2 0 0 1 2 2v5" />
      <path d="M15 23v-7h5M28 28l-2-10M23 18h6" />
      <circle cx="14" cy="38" r="3" />
      <circle cx="31" cy="38" r="3" />
      <path d="M6 42h10M24 42h12" />
      <path d="M41 7c-1.8 2.4-2.8 4.2-2.8 5.6a2.8 2.8 0 0 0 5.6 0c0-1.4-1-3.2-2.8-5.6z" />
    </>
  ),
}

export function ModuleIcoon({ id }: { id: ModuleId }) {
  return (
    <svg
      className="kiosk-tegel-icoon"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PADEN[id]}
    </svg>
  )
}

/** Pijl rechtsboven in een tegel: zegt "hier ga je naartoe" zonder woorden. */
export function Pijl() {
  return (
    <svg
      className="kiosk-tegel-pijl"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M7 17 17 7M9 7h8v8" />
    </svg>
  )
}
